
import jbs from "../assets/Ifast/jbs.JPG";
import gn from "../assets/Ifast/gaurnitai.JPG";
import kb from "../assets/Ifast/kb.JPG";
import rg from "../assets/Ifast/radhagopinath.JPG";
import "../css/deitiesPage.css";

const sections = [
  {
    name: "Sri Sri Radha Gopinath",
    image: rg,
    description:
      "These are beloved deities of Radha and Krsna installed by Bhakti Tirtha Swami, worshiped daily with great devotion and adorned with beautiful outfits and ornaments.",
    align: "right",
    fadeDirection: "right"
  },
  {
    name: "Sri Sri Gaura-Nitai",
    image: gn,
    description:
      "Lord Caitanya and Lord Nityananda, who embody divine love and mercy, were personally worshiped by Bhakti Tirtha Swami as the deliverers of the fallen age.",
    align: "left",
    fadeDirection: "left"
  },
  {
    name: "Krishna Balarama",
    image: kb,
    description:
      "Bhakti Tirtha Swami had a deep connection with Lord Balarama, whom he called upon for courage and spiritual strength.",
    align: "right",
    fadeDirection: "right"
  },
  {
    name: "Sri Jagannatha, Baladeva, Subhadra",
    image: jbs,
    description:
      "The Lord of the Universe, Jagannatha, along with His siblings, was revered by Swami as a symbol of divine joy and spiritual unity.",
    align: "left",
    fadeDirection: "left"
  }
];

const DeitiesPage = () => (

  /*  <div className="fading-sections">
        <div className="intro">
        The personal deities of Bhakti Tirtha Swami stand as sacred embodiments of his deep devotion and spiritual practice. Each deity, worshiped with heartfelt love and reverence, reflects Swami’s commitment to honoring the divine through beauty, service, and meditation. These deities are currently housed at the Washington, D.C. hub of Swami’s legacy—IFAST DC—a space lovingly preserved as his personal abode. Below is a glimpse into this sacred place where his spiritual energy continues to inspire hearts.
    </div>
      {sections.map((sec, idx) => (
        <section
          key={idx}
          className={`fading-section ${sec.align === "right" ? "reverse" : ""}`}
        >
          <div
            className={`fading-image fade-${sec.fadeDirection}`}
            style={{ backgroundImage: `url(${sec.image})` }}
          />
          <div className="fading-content">
            <h2>{sec.name}</h2>
            <p>{sec.description}</p>
          </div>
        </section>
      ))}
    </div>*/

    <div className="fading-sections">
        <div className="intro">
          These deities stand as sacred embodiments of Bhakti Tirtha Swami's deep devotion and spiritual practice. Each deity, worshiped with heartfelt love and reverence, reflects Swami’s commitment to honoring the divine through beauty, service, and meditation. These deities are currently housed at the Washington, D.C. hub of Swami’s legacy—IFAST DC—a space lovingly preserved as his personal abode. Below is a glimpse into this sacred place where his spiritual energy continues to inspire hearts.
        </div>

      {sections.map((sec, idx) => (
        <section
          key={idx}
          className={`fading-section ${sec.align === "right" ? "reverse" : ""}`}
        >
          {/* Image block is now a background image with a dedicated fade div */}
          <div
            className={`fading-image fade-${sec.fadeDirection}`}
            style={{ backgroundImage: `url(${sec.image})` }}
          />
          <div className="fading-content">
            <h2>{sec.name}</h2>
            <p>{sec.description}</p>
          </div>
        </section>
      ))}
    </div>
);

export default DeitiesPage;
